import React from 'react';
import { IconButton, TextField } from '@mui/material';
import { Clear, Search } from '@mui/icons-material';
interface SearchBoxProps {
  searchQuery: string;
  handleSearchChange: (value: string) => void;
  placeholder: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({
  searchQuery,
  handleSearchChange,
  placeholder,
}) => {
  return (
    <TextField
      placeholder={placeholder}
      value={searchQuery}
      onChange={(event) => handleSearchChange(event.target.value)}
      size="small"
      InputProps={{
        endAdornment: (
          <IconButton
            onClick={() => handleSearchChange("")}
            style={searchQuery ? {} : { visibility: "hidden" }}
          >
            <Clear />
          </IconButton>
        ),
        startAdornment: <Search />,
      }}
    />
  );
};

export default SearchBox;